import {
    // faHouse,
    faFolders,
    // faFileChartColumn, -- not in lib?
    faFileChartLine, // temporary substitute for faFileChartColumn
    faUser,
    faSparkles,
    faCreditCard,
    faHandHoldingHeart,
    faHeadset,
    faHomeLgAlt as faHouse,
} from '@fortawesome/pro-regular-svg-icons';

import { Routes } from 'routes';
import { LAUNCH_SCRIPWARE_URL } from './components/Notifications/url_constants';
import { getOrigin } from 'utils';
import { IS_FLIPGIVE } from 'common/env';
import { AccountRoles } from 'common/api/users/service';

export interface NavItem {
    title: string;
    route?: string;
    subItems?: NavItem[];
    collapsible?: boolean;
    icon?: typeof faHouse;
    startOpen?: boolean;
    openInNewTab?: boolean;
    external?: boolean;
    /** Optional stable class name for coach mark / analytics anchoring. */
    hookClassName?: string;
    /** Roles that should never see this item (e.g. Assistant Coordinators can't access Payments). */
    hideForRoles?: AccountRoles[];
}

// Note: only exporting for tests
export const navItems: NavItem[] = [
    {
        title: 'Home',
        route: Routes.CoordinatorDashboardHome,
        icon: faHouse,
    },
    {
        title: 'Participants',
        collapsible: true,
        icon: faUser,
        subItems: [
            {
                title: 'Accounts',
                route: Routes.CoordinatorDashboardParticipantAccounts,
            },
            {
                title: 'Invite Participants',
                route: Routes.CoordinatorDashboardInviteParticipants,
            },
        ],
    },
    {
        title: 'Orders',
        icon: faFolders,
        collapsible: true,
        startOpen: true,
        subItems: [
            {
                title: 'Enter Orders',
                route: Routes.CoordinatorDashboardEnterOrders,
            },
            {
                title: 'Order Queue',
                route: Routes.CoordinatorDashboardOrderQueue,
            },
            {
                title: 'PO Manager',
                route: Routes.CoordinatorDashboardPOManager,
            },
            {
                title: 'Participant Order Form',
                route: Routes.CoordinatorDashboardParticipantOrderForm,
            },
        ],
    },
    {
        title: 'Reports',
        collapsible: true,
        icon: faFileChartLine,
        subItems: [
            {
                title: 'Packing Slips',
                route: Routes.CoordinatorDashboardPackingSlips,
            },
            {
                title: 'All Reports',
                route: Routes.CoordinatorDashboardAllReports,
            },
            {
                title: 'Order History',
                route: Routes.CoordinatorDashboardOrderHistory, // Replace with the correct route for Order History
            },
        ],
    },
    {
        title: 'Organization',
        collapsible: true,
        icon: faSparkles,
        subItems: [
            {
                title: 'Profile',
                route: Routes.CoordinatorDashboardOrganizationProfile,
            },
            {
                title: 'Settings',
                route: Routes.CoordinatorDashboardOrganizationSettings,
            },
            {
                title: 'Coordinator Roles',
                route: Routes.CoordinatorDashboardCoordinatorRoles,
            },
            {
                title: 'PIN Reset',
                route: Routes.CoordinatorDashboardOrganizationPINReset,
            },
            {
                title: 'Local Products',
                route: Routes.CoordinatorDashboardLocalProducts,
            },
            {
                title: 'Local Suppliers',
                route: Routes.CoordinatorDashboardLocalSuppliers,
            },
            {
                title: 'Notifications',
                route: Routes.CoordinatorDashboardNotifications,
                hideForRoles: [AccountRoles.ASSISTANT_COORDINATOR],
            },
            {
                title: 'SCRIPWARE',
                route: `${getOrigin()}/resources/organization/scripware-inventory-management`,
                openInNewTab: true,
                external: true,
                hideForRoles: [AccountRoles.ASSISTANT_COORDINATOR],
            },
        ],
    },
    {
        title: 'Payments',
        collapsible: true,
        icon: faCreditCard,
        hideForRoles: [AccountRoles.ASSISTANT_COORDINATOR],
        subItems: [
            {
                title: 'Payment Change Form',
                route: Routes.CoordinatorDashboardPaymentChangeForm,
            },
            {
                title: 'Payment Types',
                route: Routes.CoordinatorDashboardPaymentTypes,
            },
        ],
    },
];

export const flipGiveNavItems: NavItem[] = [
    {
        title: 'Home',
        route: Routes.CoordinatorDashboardHome,
        icon: faHouse,
    },
    {
        title: 'Participants',
        collapsible: true,
        icon: faUser,
        hookClassName: 'coord_dash_nav_participants',
        subItems: [
            {
                title: 'Accounts',
                route: Routes.CoordinatorDashboardParticipantAccounts,
            },
            {
                title: 'Invite Participants',
                route: Routes.CoordinatorDashboardInviteParticipants,
            },
        ],
    },
    {
        title: 'Reports',
        collapsible: true,
        icon: faFileChartLine,
        hookClassName: 'coord_dash_nav_reports',
        subItems: [
            {
                title: 'All Reports',
                route: Routes.CoordinatorDashboardAllReports,
            },
        ],
    },
    {
        title: 'Organization',
        collapsible: true,
        icon: faSparkles,
        hookClassName: 'coord_dash_nav_organization',
        subItems: [
            {
                title: 'Profile',
                route: Routes.CoordinatorDashboardOrganizationProfile,
            },
            {
                title: 'Settings',
                route: Routes.CoordinatorDashboardOrganizationSettings,
            },
            {
                title: 'Coordinator Roles',
                route: Routes.CoordinatorDashboardCoordinatorRoles,
            },
        ],
    },
    {
        title: 'Payments',
        collapsible: true,
        icon: faCreditCard,
        hideForRoles: [AccountRoles.ASSISTANT_COORDINATOR],
        subItems: [
            {
                title: 'Payment Change Form',
                route: Routes.CoordinatorDashboardPaymentChangeForm,
            },
            {
                title: 'Payment Types',
                route: Routes.CoordinatorDashboardPaymentTypes,
            },
        ],
    },
];

export const scripwareNavItems: NavItem[] = [
    {
        title: 'Home',
        route: Routes.CoordinatorDashboardHome,
        icon: faHouse,
    },
    {
        title: 'Participants',
        collapsible: true,
        icon: faUser,
        subItems: [
            {
                title: 'Invite Participants',
                route: Routes.CoordinatorDashboardInviteParticipants,
            },
        ],
    },
    {
        title: 'Orders',
        icon: faFolders,
        collapsible: true,
        subItems: [
            {
                title: 'Participant Order Form',
                route: Routes.CoordinatorDashboardParticipantOrderForm,
            },
        ],
    },
    {
        title: 'Reports',
        collapsible: true,
        icon: faFileChartLine, // Change this to faFileChartColumn when available
        subItems: [
            {
                title: 'Order History',
                route: Routes.CoordinatorDashboardOrderHistory, // Replace with the correct route for Order History
            },
        ],
    },
    {
        title: 'Organization',
        collapsible: true,
        icon: faSparkles,
        subItems: [
            {
                title: 'Profile',
                route: Routes.CoordinatorDashboardOrganizationProfile,
            },
            {
                title: 'Settings',
                route: Routes.CoordinatorDashboardOrganizationSettings,
            },
            {
                title: 'Coordinator Roles',
                route: Routes.CoordinatorDashboardCoordinatorRoles,
            },
            {
                title: 'PIN Reset',
                route: Routes.CoordinatorDashboardOrganizationPINReset,
            },
            {
                title: 'SCRIPWARE',
                // env/c/account/scripware
                route: LAUNCH_SCRIPWARE_URL,
                external: true,
                hideForRoles: [AccountRoles.ASSISTANT_COORDINATOR],
            },
        ],
    },
    {
        title: 'Payments',
        collapsible: true,
        icon: faCreditCard,
        hideForRoles: [AccountRoles.ASSISTANT_COORDINATOR],
        subItems: [
            {
                title: 'Payment Change Form',
                route: Routes.CoordinatorDashboardPaymentChangeForm,
            },
            {
                title: 'Payment Types',
                route: Routes.CoordinatorDashboardPaymentTypes,
            },
        ],
    },
];

export type SectionConfig = {
    title: string;
    items: NavItem[];
};

export const resourcesSection = {
    title: 'Resources',
    items: [
        {
            title: IS_FLIPGIVE ? 'Resource Centre' : 'Resource Center',
            route: IS_FLIPGIVE
                ? `https://www.flipgive.com${Routes.SupportOrganization}`
                : Routes.SupportOrganization,
            icon: faHandHoldingHeart,
            external: true,
        },
        {
            title: 'Customer Support',
            route: IS_FLIPGIVE ? `https://www.flipgive.com${Routes.Contact}` : Routes.Contact,
            icon: faHeadset,
            external: true,
        },
    ],
};

function filterNavItemsForRole(items: NavItem[], role?: AccountRoles): NavItem[] {
    return items
        .filter((item) => !role || !item.hideForRoles?.includes(role))
        .map((item) =>
            item.subItems ? { ...item, subItems: filterNavItemsForRole(item.subItems, role) } : item
        );
}

/**
 * Invite Hub (enable_coordinator_invite_hub_web): the "Participants" entry becomes a
 * direct link to the new Participants page instead of the legacy collapsible sub-menu.
 */
function applyInviteHubNav(items: NavItem[], isInviteHubEnabled: boolean): NavItem[] {
    if (!isInviteHubEnabled) {
        return items;
    }

    return items.map((item) =>
        item.title === 'Participants'
            ? {
                  title: item.title,
                  route: Routes.CoordinatorDashboardParticipantAccounts,
                  icon: item.icon,
                  hookClassName: item.hookClassName,
              }
            : item
    );
}

export function getSections(
    isScripware: boolean,
    role?: AccountRoles,
    isInviteHubEnabled = false
): SectionConfig[] {
    const getNavItems = () => {
        if (IS_FLIPGIVE) {
            return flipGiveNavItems;
        }
        if (isScripware) {
            return scripwareNavItems;
        }
        return navItems;
    };

    return [
        {
            title: 'Main Menu',
            items: applyInviteHubNav(
                filterNavItemsForRole(getNavItems(), role),
                isInviteHubEnabled
            ),
        },
        resourcesSection,
    ];
}
